/**
 * Función para limpìar la url que se está visitando
 */

export function cleanUrlForHash() {
  const getHostname = window.location.hostname.replace('www.', '')
  const getPathname = window.location.pathname.replaceAll('/', '')
  const cleanedURL = getHostname + getPathname

  console.log(cleanedURL)
  console.log(cleanedURL.split(';', 1).join(''))

  return cleanedURL.includes(';')
    ? cleanedURL.split(';', 1).join('')
    : cleanedURL
}
